import React, { useState } from 'react';
import { Modal, Select, Spin, Button } from 'antd';
import { useGetMatGapMaster } from '../../hooks/genericHooks';

// Accept unified dynamic modal props
interface GapMasterMaterialSelectProps {
  open: boolean;
  value?: any;
  onOk: (value: any) => void;
  onCancel: () => void;
  options?: any[];
}

const GapMasterMaterialSelect: React.FC<GapMasterMaterialSelectProps> = ({ open, value, onOk, onCancel }) => {
  const { data: gapMasterData, isLoading } = useGetMatGapMaster();
  const [selectedId, setSelectedId] = useState<string | number | null>(value ?? null);

  // Keep internal state in sync with prop
  React.useEffect(() => {
    setSelectedId(value ?? null);
  }, [value]);

  const gapMasterList = Array.isArray(gapMasterData)
    ? gapMasterData
    : (gapMasterData?.data || []);

  return (
    <Modal
      open={open}
      title="Select Gap Master Material"
      closable={true}
      getContainer={false}
      footer={[
        <Button key="cancel" onClick={onCancel}>Cancel</Button>,
        <Button
          key="ok"
          type="primary"
          onClick={() => {
            const selectedMaterial = gapMasterList.find((material: any) => material["Malzeme"] === selectedId);
            if (selectedMaterial) {
              onOk(`${selectedMaterial["Malzeme"]} - ${selectedMaterial["Malzeme kısa metni"] || selectedMaterial["Malzeme uzun tanımı"] || 'No description'}`);
            }
          }}
          disabled={!selectedId}
        >
          Select
        </Button>
      ]}
      destroyOnClose
      onCancel={onCancel}
    >
      <Spin spinning={isLoading}>
        <Select
          showSearch
          style={{ width: '100%', borderRadius: 0, background: '#e6f2ff', border: 'none' }}
          placeholder="Select a material from Gap Master"
          value={selectedId ?? undefined}
          onChange={setSelectedId}
          optionFilterProp="children"
          dropdownStyle={{ borderRadius: 0 }}
          filterOption={(input, option) =>
            String(option?.children).toLowerCase().includes(input.toLowerCase())
          }
        >
          {gapMasterList.map((material: any) => (
            <Select.Option
              key={material["Malzeme"]}
              value={material["Malzeme"]}
              title={`${material["Malzeme"]} - ${material["Malzeme kısa metni"] || material["Malzeme uzun tanımı"] || 'No description'}`}
            >
              {material["Malzeme"]} - {material["Malzeme kısa metni"] || material["Malzeme uzun tanımı"] || 'No description'}
            </Select.Option>
          ))}
        </Select>
      </Spin>
    </Modal>
  );
};

export default GapMasterMaterialSelect;
